(() => {
  // Update ATC text to: "Add to cart — $X.XX"
  // Designed for Prestige 10+ (dynamic re-renders) without MutationObserver.

  const ATC_SELECTOR = 'buy-buttons button[type="submit"]';

  // Try common Prestige price elements (v10 uses web components like <sale-price>/<regular-price>)
  const PRICE_SELECTORS = [
    'sale-price',
    'regular-price',
    '.price-list .price',
    '.product-info__price .price',
    '.price',
    '[data-price]'
  ];

  function getText(el) {
  if (!el) return '';
  let txt = (el.textContent || '').replace(/\s+/g, ' ').trim();

  // Remove Shopify sale labels
  txt = txt.replace(/sale price/i, '');
  txt = txt.replace(/regular price/i, '');
  txt = txt.trim();

  return txt;
}

  function findPriceText(scope) {
    for (const sel of PRICE_SELECTORS) {
      const els = scope.querySelectorAll(sel);
      for (const el of els) {
        const t = getText(el);
        // basic sanity check: contains a digit
        if (t && /\d/.test(t)) return t;
      }
    }
    return '';
  }

  function updateButton(btn) {
    if (!btn) return;

    // Store the original label once (supports translations)
    if (!btn.dataset.baseLabel) {
      btn.dataset.baseLabel = getText(btn) || 'Add to cart';
    }

    // Find closest product section/container to search price within
    const scope =
      btn.closest('.shopify-section') ||
      btn.closest('main') ||
      document;

    const price = findPriceText(scope);
    if (!price) return;

    const base = btn.dataset.baseLabel;

    // Prevent double-appending
    const next = `${base} — ${price}`;
    if (getText(btn) !== next) btn.textContent = next;
  }

  function updateAll() {
    document.querySelectorAll(ATC_SELECTOR).forEach(updateButton);
  }

  function safeUpdateAll() {
    try {
      updateAll();
    } catch (e) {
      // Never let this script break the theme
      console.warn('[ATC price] update failed:', e);
    }
  }

  // Run on load
  document.addEventListener('DOMContentLoaded', () => {
    safeUpdateAll();
    // Second pass after theme renders components
    setTimeout(safeUpdateAll, 120);
  });

  // Shopify editor re-renders
  document.addEventListener('shopify:section:load', () => {
    safeUpdateAll();
    setTimeout(safeUpdateAll, 120);
  });

  // Variant change (Prestige commonly triggers change events on option inputs)
  document.addEventListener('change', (e) => {
    if (!e.target) return;
    // Only react if the change is inside a product form area
    const withinProduct = e.target.closest('product-form, form[action^="/cart/add"], .product');
    if (!withinProduct) return;

    // Let Prestige update price first, then update button
    requestAnimationFrame(safeUpdateAll);
    setTimeout(safeUpdateAll, 120);
  });
})();